import { createFileRoute, Link } from "@tanstack/react-router";
import { motion } from "framer-motion";
import React from "react";

import LoginForm from "@/components/auth/LoginForm";
import Logo from "@/components/ui/logo";
import AuthBG from "@/images/bg-auth.png";
import AuthBG2x from "@/images/bg-auth@2x.png";

export const Route = createFileRoute("/_auth/login")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <section className="relative min-h-screen flex justify-center">
      <div className="mt-8 md:mt-24 md:min-w-[400px] md:max-w-[400px] w-full">
        <motion.div
          className="flex justify-center"
          initial={{ opacity: 0, y: 20 }}
          transition={{ duration: 0.5 }}
          animate={{
            opacity: [0, 1],
            y: 0,
          }}
        >
          <Link className="flex" to="/">
            <Logo />
          </Link>
        </motion.div>
        <motion.div
          className="mt-7"
          initial={{ opacity: 0, y: 20 }}
          transition={{ duration: 0.5, delay: 0.5 }}
          layout
          animate={{
            opacity: [0, 1],
            y: 0,
          }}
          exit={{ opacity: 0, y: 20 }}
        >
          <h1 className="text-[18px] text-center m-0 p-0 text-[#44596C] font-[Gordita-Medium]">
            Login to ClientZen
          </h1>
          <LoginForm />
          <div className="mt-4 px-4 md:px-0 font-[Gordita-Regular] flex justify-center  text-sm">
            <Link className="text-[#44596C]" to="/forgot-password">
              Forgot password?
            </Link>
            <Link className="text-[#44596C] hide" to="/register">
              No account
            </Link>
          </div>
        </motion.div>
        <motion.img
          initial={{ opacity: 0, y: 20 }}
          transition={{ duration: 0.5, delay: 0.5 }}
          layout
          animate={{
            opacity: [0, 1],
            y: 0,
          }}
          exit={{ opacity: 0, y: 20 }}
          src={AuthBG}
          srcSet={`${AuthBG2x} 2x`}
          alt="bg-auth"
          className="absolute bottom-0 left-0 w-full -z-10"
        />
      </div>
    </section>
  );
}
